// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* ACTUALLY, THIS IS EDITED ;)
THIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST
GRID UNITS.

ALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM \`layout-contents.js\`*/

/* layout contants from \`layout-constants.js\`, minus 1px */

/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* 35% transparent version of looks-secondary */

.label_input-group_zFwNI {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
      -ms-flex-direction: row;
          flex-direction: row;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
}

[dir='ltr'] .label_input-group_zFwNI + .label_input-group_zFwNI {
  margin-left: calc(2 * 0.25rem);
}

[dir='rtl'] .label_input-group_zFwNI + .label_input-group_zFwNI {
  margin-right: calc(2 * 0.25rem);
}

.label_disabled_V0UWm {
  opacity: 0.3;
  /* Prevent any user actions */
  pointer-events: none;
}

.label_input-label_QChqm,
.label_input-label-secondary__AdEl {
  font-size: 0.625rem;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  cursor: default;
}

[dir='ltr'] .label_input-label_QChqm,
[dir='ltr'] .label_input-label-secondary__AdEl {
  margin-right: calc(2 * 0.25rem);
}

[dir='rtl'] .label_input-label_QChqm,
[dir='ltr'] .label_input-label-secondary__AdEl {
  margin-left: calc(2 * 0.25rem);
}

.label_input-label_QChqm {
  font-weight: bold;
}

@media only screen and (max-width: 1256px) {
  .label_input-group_zFwNI {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
        -ms-flex-align: start;
            align-items: flex-start;
    margin-top: -1rem; /* To align with the non-labeled inputs */
  }

  .label_input-label_QChqm {
    font-weight: normal;
    margin-bottom: 0.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/forms/label.css"],"names":[],"mappings":"AAAA;;oDAEoD;;AAEpD;;oDAEoD;;AAEpD;;;;kFAIkF;;AAElF,0DAA0D;;AAE1D;;oDAEoD;;AAEpD,+CAA+C;;AAE/C;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;MACvB,uBAAuB;UACnB,mBAAmB;EAC3B,yBAAyB;EACzB,2BAA2B;MACvB,sBAAsB;UAClB,mBAAmB;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,eAAe;AACjB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,4BAA4B;IAC5B,6BAA6B;IAC7B,8BAA8B;QAC1B,0BAA0B;YACtB,sBAAsB;IAC9B,wBAAwB;IACxB,+BAA+B;QAC3B,qBAAqB;YACjB,uBAAuB;IAC/B,iBAAiB,EAAE,yCAAyC;EAC9D;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF","sourcesContent":["/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* ACTUALLY, THIS IS EDITED ;)\nTHIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST\nGRID UNITS.\n\nALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM `layout-contents.js`*/\n\n/* layout contants from `layout-constants.js`, minus 1px */\n\n/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* 35% transparent version of looks-secondary */\n\n.input-group {\n  display: -webkit-inline-box;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n[dir='ltr'] .input-group + .input-group {\n  margin-left: calc(2 * 0.25rem);\n}\n\n[dir='rtl'] .input-group + .input-group {\n  margin-right: calc(2 * 0.25rem);\n}\n\n.disabled {\n  opacity: 0.3;\n  /* Prevent any user actions */\n  pointer-events: none;\n}\n\n.input-label,\n.input-label-secondary {\n  font-size: 0.625rem;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: default;\n}\n\n[dir='ltr'] .input-label,\n[dir='ltr'] .input-label-secondary {\n  margin-right: calc(2 * 0.25rem);\n}\n\n[dir='rtl'] .input-label,\n[dir='ltr'] .input-label-secondary {\n  margin-left: calc(2 * 0.25rem);\n}\n\n.input-label {\n  font-weight: bold;\n}\n\n@media only screen and (max-width: 1256px) {\n  .input-group {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: start;\n    -webkit-align-items: flex-start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    margin-top: -1rem; /* To align with the non-labeled inputs */\n  }\n\n  .input-label {\n    font-weight: normal;\n    margin-bottom: 0.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input-group": `label_input-group_zFwNI`,
	"inputGroup": `label_input-group_zFwNI`,
	"disabled": `label_disabled_V0UWm`,
	"input-label": `label_input-label_QChqm`,
	"inputLabel": `label_input-label_QChqm`,
	"input-label-secondary": `label_input-label-secondary__AdEl`,
	"inputLabelSecondary": `label_input-label-secondary__AdEl`
};
export default ___CSS_LOADER_EXPORT___;
